export default __webpack_public_path__ + "static/media/v5_4_turkoosi.0f9cfba2.png";